<template>
  <div>
    <page-heading :title="$t(`${translationPrefix}.title`)"></page-heading>

    <content-placeholder v-if="processing || !currentUserMembership">
      <el-card>
        <p class="text text-75"></p>
        <p class="text text-full"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
      </el-card>
    </content-placeholder>

    <el-card v-else>
      <div align="center" v-if="currentUserMembership.user_id">
        <p>You have been invited to Timeclock application. Please click below button to accept invitation</p>
        <el-button type="primary" @click="acceptInvitation" :loading="processing">{{ $t('buttons.acceptInvitation') }}</el-button>
      </div>

      <div v-else>
        <p>You have been invited to Timeclock application. Please fill out below form to accept invitation</p>

        <el-form
          ref="invitationForm"
          :model="formData"
          :rules="rules"
          :label-width="$root.labelWidth"
          label-position="right"
          v-loading="processing"
        >

          <el-form-item :label="$t('modules.profile.fields.firstName.label')" prop="firstName">
            <el-input type="text" v-model.lazy.trim="formData.profile_attributes.first_name" :placeholder="$t('modules.profile.fields.firstName.placeholder')"></el-input>
          </el-form-item>

          <el-form-item :label="$t('modules.profile.fields.lastName.label')" prop="lastName">
            <el-input type="text" v-model.lazy.trim="formData.profile_attributes.last_name" :placeholder="$t('modules.profile.fields.lastName.placeholder')"></el-input>
          </el-form-item>

          <el-form-item :label="$t('modules.user.fields.password.label')" prop="password">
            <el-input type="password" v-model.lazy.trim="formData.password" :placeholder="$t('modules.user.fields.password.placeholder')"></el-input>
          </el-form-item>

          <el-form-item :label="$t('modules.user.fields.passwordConfirmation.label')" prop="passwordConfirmation">
            <el-input type="password" v-model.lazy.trim="formData.password_confirmation" :placeholder="$t('modules.user.fields.passwordConfirmation.placeholder')"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('invitationForm')">{{ $t('buttons.submit') }}</el-button>
          </el-form-item>

        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import { showSuccessMessage, showErrorMessage } from '@/ui/message';
  import validations from '@/utils/validations';

  export default {
    name: 'InvitationPage',
    created() {
      this.$store.dispatch('entities/userMemberships/validateInvitationToken', this.invitationToken)
        .then((response) => {
          if (response.status) {
            this.userMembershipId = response.data.entity.id;
          }
        });
    },
    data() {
      return {
        translationPrefix: 'pages.invitation',
        invitationToken: this.$router.currentRoute.query.invitation_token,
        userMembershipId: null,
        rules: {
          password: [
            { ...validations.required },
          ],
          password_confirmation: [
            { ...validations.required },
          ],
          profile_attributes: {
            first_name: [
              { ...validations.required },
            ],
            last_name: [
              { ...validations.required },
            ],
          },
        },
        formData: {
          email: '',
          company_id: '',
          password: '',
          password_confirmation: '',
          profile_attributes: {
            first_name: '',
            last_name: '',
          },
        },
      };
    },
    computed: {
      ...mapGetters('entities/userMemberships', ['processing']),

      locale() {
        return this.$store.getters.locale;
      },
      currentUserMembership() {
        return this.$store.getters['entities/userMemberships/query']().first(this.userMembershipId);
      },
    },
    methods: {
      acceptInvitation() {
        const data = {
          ...this.formData,
          invitation_token: this.invitationToken,
          locale: this.locale,
          email: this.currentUserMembership.invitation_email,
          company_id: this.currentUserMembership.company_id,
        };

        this.$store.dispatch('entities/userMemberships/acceptInvitation', data)
          .then((response) => {
            if (response.status) {
              if (this.currentUserMembership.user_id) {
                showSuccessMessage('Thank you for accepting invitation. Please log in.');
              } else {
                showSuccessMessage('Thank you for accepting invitation. Confirmation email has been sent you your email address.');
              }

              this.$router.push({ name: 'home' });
            } else {
              showErrorMessage(response.error);
            }
          });
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.acceptInvitation();
          } else {
            showErrorMessage(this.$t('form.messages.notValid'));

            return false;
          }

          return true;
        });
      },
    },
  };
</script>




// WEBPACK FOOTER //
// src/pages/Invitation.vue